/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台-pgc稿件管理
 */
'use strict';
angular.module("pgcManageModule",[
    'pgcManageRouterModule',
    'reviewManuscriptModule',//待审稿件
    'hasBeenModule',//pgc-已审稿件
    'channelManagementModule',//渠道管理
    'labelManagementModule',//标签管理
    'firstLevelLabelModule',//标签管理-一级标签
    'twoLevelLabelModule',
    'documentDetailModule'
]).
controller('pgcManageCtrl', ['$scope',function($scope){
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus(){
        $scope.status = {
            inputData:''
        }
    };

    function initData(){

    };
}]);